import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getSubinventoryInfoByPlant } from '../../api/production-request-api/index.js';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to fetch subinventory information by plant.
 * @param {Pella.ProductionRequestAPI.GetSubinventoryInfoByPlantInput} input - The input parameters to retrieve the subinventory information.
 */
export const useSubinventoryInfo = (input) => {
  const { apiReady } = useApiReady();

  return useQuery({
    queryKey: [QUERY_KEYS.SUBINVENTORY_INFO, input],
    queryFn: () => getSubinventoryInfoByPlant(input),
    enabled: Boolean(apiReady && input?.inventoryItemId && input?.organizationId && input?.subinventoryCode),
  });
};
